// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"105afd9a","817":"105afd9a","972":"105afd9a"}[chunkId] + ".chunk.css";
};